export const statuses = {
  draft: "draft",
  new: "new",
  planned: "planned",
  inProcess: "in process",
  completed: "completed",
  rejected: "rejected",
  confirmed: "confirmed",
};

export const ticketProps = {
  assignee: "assignee",
  requester: "requester",
  contributors: "contributors",
  status: "status",
  dueDate: "dueDate",
  startDate: "startDate",
  priority: "priority",
  createdBy: "createdBy",
  workCarriedOut: "workCarriedOut",
  maintenanceRequestType: "maintenanceRequestType",
  actualMaintenanceTime: "actualMaintenanceTime",
  ticketNumber: "ticketNumber",
};
